import {all, call, put, takeLatest} from '@redux-saga/core/effects';
import {
  INTERVIEW_BOOKED_DASHBOARD, interviewBookedDashboardSearchError, interviewBookedDashboardSearchSuccess,
  PROFILE_READY_DASHBOARD, profileReadyDashboardSearchError, profileReadyDashboardSearchSuccess,
  SENT_TO_EMPLOYER_DASHBOARD, sentToEmployerDashboardSearchError, sentToEmployerDashboardSearchSuccess,
  DASHBOARD_PRESET, dashboardPresetLoadError, dashboardPresetLoadSuccess, dashboardPresetRefresh,
  dashboardPresetSaveError,
  dashboardPresetSaveSuccess,
} from './Actions';
import authApi from '../../@template/services/auth/authApi/authenticatedApi';
import {apiConfig} from '../../config';
import {PayloadAction} from '@reduxjs/toolkit';
import {ISearchRequest} from '../../types/common/SearchRequest';
import {PersonSearchResultPaged} from '../../types/views/PersonSearchResultPaged';
import {ScorecardParamsModel} from '../../types/requests/ScorecardParamsModel';
import {DashboardOppParamsModel} from '../../types/requests/DashboardOppParamsModel';
import {OpportunityStudentViewOpportunityStudentStatus} from '../../types/models/Enums';


function* SearchInterviewBookedDashboard({ page, sort, searchParams }: ISearchRequest<DashboardOppParamsModel>) {
  console.log('SAGA - dashboardSaga - SearchInterviewBookedDashboard');
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'PUT',
      url: `${apiConfig.coreOpportunitiesPath}/dashboard-opportunity-status-search`,
      data: searchParams
    });
    const results: PersonSearchResultPaged = PersonSearchResultPaged.fromJS(res.data);
    yield put(interviewBookedDashboardSearchSuccess(results));
  } catch (error) {
    yield put(interviewBookedDashboardSearchError(error));
  }
}

function* SearchProfileReadyDashboard({ page, sort, searchParams }: ISearchRequest<DashboardOppParamsModel>) {
  console.log('SAGA - dashboardSaga - SearchProfileReadyDashboard');
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'PUT',
      url: `${apiConfig.coreOpportunitiesPath}/dashboard-opportunity-status-search`,
      data: searchParams
    });

    const results: PersonSearchResultPaged = PersonSearchResultPaged.fromJS(res.data);
    console.log('SearchProfileReadyDashboard results', results);
    yield put(profileReadyDashboardSearchSuccess(results));
  } catch (error) {
    console.log('ERROR!!', error);
    yield put(profileReadyDashboardSearchError(error));
  }
}

function* SearchSentToEmployerDashboard({ page, sort, searchParams }: ISearchRequest<DashboardOppParamsModel>) {
  console.log('SAGA - dashboardSaga - SearchSentToEmpoyerDashboard');
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'PUT',
      url: `${apiConfig.coreOpportunitiesPath}/dashboard-opportunity-status-search`,
      data: searchParams
    });
    const results: PersonSearchResultPaged = PersonSearchResultPaged.fromJS(res.data);
    yield put(sentToEmployerDashboardSearchSuccess(results));
  } catch (error) {
    yield put(sentToEmployerDashboardSearchError(error));
  }
}


export function* watchInterviewBookedDashboardSearch() {
  yield takeLatest(INTERVIEW_BOOKED_DASHBOARD.LOAD, ({payload}: PayloadAction<ISearchRequest<DashboardOppParamsModel>>) => SearchInterviewBookedDashboard(payload))
}

export function* watchProfileReadyDashboardSearch() {
  yield takeLatest(PROFILE_READY_DASHBOARD.LOAD, ({payload}: PayloadAction<ISearchRequest<ScorecardParamsModel>>) => SearchProfileReadyDashboard(payload))
}

export function* watchSentToEmployerDashboardSearch() {
  yield takeLatest(SENT_TO_EMPLOYER_DASHBOARD.LOAD, ({payload}: PayloadAction<ISearchRequest<ScorecardParamsModel>>) => SearchSentToEmployerDashboard(payload))
}



export default function* dashboardSaga() {
  yield all ([
    call(watchInterviewBookedDashboardSearch),
    call(watchProfileReadyDashboardSearch),
    call(watchSentToEmployerDashboardSearch),
  ])
}
